import { render, staticRenderFns } from "./TestMarker.vue?vue&type=template&id=0dd41b2e&scoped=true&"
import script from "./TestMarker.vue?vue&type=script&lang=js&"
export * from "./TestMarker.vue?vue&type=script&lang=js&"
import style0 from "./TestMarker.vue?vue&type=style&index=0&id=0dd41b2e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd41b2e",
  null
  
)

export default component.exports